/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Era5DownloadJob } from '../models/Era5DownloadJob';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class Era5API {

  /**
   * Get All Download Jobs
   * @returns Era5DownloadJob Successful Response
   * @throws ApiError
   */
  public static getAllDownloadJobs(): CancelablePromise<Array<Era5DownloadJob>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/era5',
      errors: {
        401: `Unauthorized`,
      },
    });
  }

  /**
   * Create Download Job
   * @returns Era5DownloadJob Successful Response
   * @throws ApiError
   */
  public static createDownloadJob({
    requestBody,
  }: {
    requestBody: Era5DownloadJob,
  }): CancelablePromise<Era5DownloadJob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/era5',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        422: `Validation Error`,
      },
    });
  }

}
